import { useEffect } from 'react';

/** Prevent blank area after switching tabs when keyboard is open */
export default function useResetScrollYOnFocus() {
  useEffect(() => {
    const handleFocus = () => {
      if (document.activeElement) {
        (document.activeElement as HTMLElement).blur();
      }
      window.scrollTo(0, 0);
    };
    document.addEventListener('visibilitychange', handleFocus);
    return () => {
      document.removeEventListener('visibilitychange', handleFocus);
    };
  }, []);
}
